import { Splide, SplideSlide } from '@splidejs/react-splide'
import Image from 'next/future/image'
import '@splidejs/react-splide/css'

export default function ComponentBlocksGallery ({ Images }) {
  const options = {
    type: 'loop',
    start: 0
  }

  return (
    <div className="col-12">
      <Splide options={options}>
        {
          Images.data.map((image, index) => (
            <SplideSlide key={index}
              className="d-flex justify-content-center align-items-center"
            >
              <Image
                alt=""
                src={`${process.env.NEXT_PUBLIC_CMS_URL}${image.attributes.url}`}
                width={image.attributes.width}
                height={image.attributes.height}
                className="img-fluid"
                id={ `slideimage${index}` }
              />
            </SplideSlide>
          ))
        }
      </Splide>
    </div>
  )
}
